<!--echart-->
<template>
  <div class="echart-container">
    <div class="echart-target" ref="echartTarget"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    options: {
      type: Object,
      require: true,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    options() {
      this.update();
    },
  },
  created() {},
  mounted() {
    this.init();
    this.registEvent();
    this.update();
  },
  methods: {
    init() {
      this.chart = echarts.init(this.$refs['echartTarget']);
    },
    update() {
      this.chart.setOption(this.options);
    },
    registEvent() {
      let _this = this;
      bind(
        window,
        'resize',
        function () {
          _this.chart.resize();
        },
        false
      );
    },
  },
};

function bind(el, eventName, fn) {
  if (window.addEventListener) {
    el.addEventListener(eventName, fn, false);
  } else if (window.attachEvent) {
    el.attachEvent('on' + eventName, fn);
  }
}
</script>
<style lang="scss" type="text/scss">
.echart-container {
  @include wh100;
  .echart-target {
    @include wh100;
  }
}
</style>
